import type React from 'react';
import { Suspense } from 'react';
import { CompanyLogo, type CompanyLogoProps } from './CompanyLogo';
import { CompanyLogoStub } from './CompanyLogo';

export const CompanyLogoSuspense: React.FC<CompanyLogoProps> = (props) => (
    <Suspense fallback={<CompanyLogoStub {...props} />}>
        <CompanyLogo {...props} />
    </Suspense>
);
